import { useCallback, useState } from 'react';
import api from '../api/api';
import { notify } from '../utils/notifications';

const CLOSE_CONFIRM_MESSAGE =
    'Closing this case will archive it and permanently delete patient data. This cannot be undone. Continue?';

export function useUpdateAdmissionStatus({ caseId, currentStatus, onOptimisticChange }) {
    const [isPending, setIsPending] = useState(false);

    const change = useCallback(async (newStatus) => {
        if (newStatus === currentStatus) return;

        if (newStatus === 'Closed') {
            const ok = window.confirm(CLOSE_CONFIRM_MESSAGE);
            if (!ok) return;
        }

        onOptimisticChange(newStatus);
        setIsPending(true);

        try {
            const body = new URLSearchParams();
            body.append('case_id', caseId);
            body.append('admission_status', newStatus);
            await api.post('/case/set-admission-status', body, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true,
            });
        } catch (err) {
            notify.error('Failed to update admission status');
            onOptimisticChange(currentStatus);
        } finally {
            setIsPending(false);
        }
    }, [caseId, currentStatus, onOptimisticChange]);

    return { change, isPending };
}

export default useUpdateAdmissionStatus;
